// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"295":"dc0f8b68","466":"da5f614e"}[chunkId] + ".css";
};